import { format, parseISO, intlFormat } from 'date-fns/esm'
import { utcToZonedTime } from 'date-fns-tz'

export const TimeZoneEST = 'America/New_York'

export function formattedDateTime(isoDateTime: string) {
  if (!isoDateTime) return null
  return format(parseISO(isoDateTime), 'MMM d, yyyy h:mm aa')
}

export function formattedShortDateTime(isoDateTime: string) {
  if (!isoDateTime) return null
  return format(parseISO(isoDateTime), 'MMM d, h:mm aa')
}

export function formattedDate(isoDateTime: string) {
  if (!isoDateTime) return null
  return format(parseISO(isoDateTime), 'MMM d, yyyy')
}

export function formattedDateWithTimeZone(
  isoDateTime: string,
  timeZone: string = 'UTC',
) {
  if (!isoDateTime) return null
  try {
    return format(utcToZonedTime(isoDateTime, timeZone), 'MMM d, yyyy')
  } catch {
    return null
  }
}

export function formattedTime(isoDateTime: string) {
  if (!isoDateTime) return null
  return format(parseISO(isoDateTime), 'h:mm aa')
}

export function formattedTimeWithTimeZone(
  isoDateTime: string,
  timeZone?: string,
  locales: string | string[] = 'default',
) {
  if (!isoDateTime) return null
  return intlFormat(
    parseISO(isoDateTime),
    { hour: 'numeric', minute: 'numeric', timeZone },
    { locale: locales },
  )
}
